// extracted by mini-css-extract-plugin
export default {"white":"#fff","notificationRed":"#ff4c68","primaryIcon":"#309df0","PlusBadge":"beq_a bic_rj bic_rk bic_vh bic_eb bic_vf bic_gs bic_kh"};